import { render, staticRenderFns } from "./AssetList.vue?vue&type=template&id=2d3479a2"
import script from "./AssetList.vue?vue&type=script&lang=js"
export * from "./AssetList.vue?vue&type=script&lang=js"
import style0 from "./AssetList.vue?vue&type=style&index=0&id=2d3479a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports